import { render, staticRenderFns } from "./ShopCheapComponent.vue?vue&type=template&id=7165e8bc&scoped=true&"
import script from "./ShopCheapComponent.vue?vue&type=script&lang=js&"
export * from "./ShopCheapComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165e8bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
